<template>
  <div>
    <vue-dropzone
    ref="myVueDropzone"
    id="dropzone"
    v-on:vdropzone-error="error"
    :options="dropzoneOptions"
    v-on:vdropzone-success="setOrderDocsUrl"
    v-on:vdropzone-removed-file="removeOrderDocsUrl"
    class="mb-0">
  </vue-dropzone>
  <p class="px-2 py-2 h6 text-danger" v-if="this.errorMessage">{{this.errorMessage }}</p>
  </div>
</template>

<script>
import VueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'CustomVueDropzone',
  components: {
    VueDropzone
  },
  props: {
    dropzoneMessage: {
      type: String,
      default: 'Documents'
    },
    maxFile: {
      type: Number,
      default: 1
    },
    allowedFileTypes: {
      type: Array,
      default: ['.pdf', '.png', '.jpg', '.jpeg']
    }
  },
  data () {
    return {
      errorMessage: '',
      dropzoneOptions: {
        url: 'https://upload.keepneye.com/upload',
        thumbnailWidth: 200,
        maxFilesize: 10.5,
        addRemoveLinks: true,
        maxFiles: this.maxFile,
        acceptedFiles: this.allowedFileTypes.join(','),
        dictDefaultMessage: this.dropzoneMessage + `. (10.5 Mb MAX) [${this.allowedFileTypes.join(',')}]`,
        renameFile: function (file) {
          let newName = Math.random().toString(36).substr(2, 9) + '_' + file.name
          return newName
        }
      }
    }
  },

  methods: {
    // Custom Input file: VueDropZone file upload successful
    // Set URL for order doc
    setOrderDocsUrl (file, response) {
      const dropzoneFile = response.data.URL
      this.emitNewDropzoneFile(dropzoneFile)
    },

    error (file, message) {
      this.errorMessage = message
  },

    // Custom Input file, functions: VueDropZone file removed
    // Reset order docs, remove file from dropzone. re-enable dropzone
    removeOrderDocsUrl (file, error, xhr) {
      const dropzoneFile = ''
      this.$refs.myVueDropzone.removeAllFiles()
      this.$refs.myVueDropzone.enable()
      this.errorMessage = ''

      this.emitNewDropzoneFile(dropzoneFile)
    },

    emitNewDropzoneFile (file) {
      this.$emit('dropzoneFile', file)
    }
  }
}
</script>

<style scoped>
</style>
